import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import {CardActions} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import {getCategoryByValue, getCategoryDescriptionByValue} from "./JobCard";



export default function OpportunityCard({opportunity, clientId}) {

    return (
        <Card style={{maxWidth: '436px', borderRadius: 20, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent style={{ flexGrow: 1 }}>

                <h3-bold style={{display: 'flex'}}>{getCategoryByValue(opportunity.jobcategory)} <Avatar sx={{width: 22, height: 22, bgcolor: 'black', ml:1, mb: 1}}>{opportunity.count}</Avatar></h3-bold>
                <br/>
                <body>{getCategoryDescriptionByValue(opportunity.jobcategory)}</body>
                <br/>
            </CardContent>
            <CardActions>
                <Button href={`/JobListing?clientId=${clientId}`} style={{
                    borderRadius: 11,
                    marginLeft: 10,
                    marginBottom: 10,
                    float: "left",
                    backgroundColor: '#FF6600',
                    fontFamily: 'Poppins',
                    color: '#FFFFFF',
                }}>View Opportunities</Button>
            </CardActions>
        </Card>
    )
}